import { makeModel } from "../../../service/utils/utils.service";
import { TotalModel } from "./total/total.model";
import { SyscodeModel } from "./syscode.model";
import { GenericModel } from "../../generic.model";
import { HostModel } from "../common/host.model";
import { CustomerModel } from "./customer/customer.model";
import { VehicleModel } from "./vehicle/vehicle.model";
import { VehicleRentalModel } from "./vehicleRental/vehicleRental.model";
import { ServiceModel } from "./service/service.model";
import { TravellerModel } from "./traveller/traveller.model";
import { AgencyModel } from "../common/agency.model";
import { PriceModel } from "./price/price.model";
import { VoucherModel } from "./voucher/voucher.model";
import { ProductModel } from "./product.model";
import { OwnerModel } from "./owner/owner.model";
import {
    EVehicleRowType,
    IVehicleRentalPriceRow
} from "../../../component/booking-information/components/booking-price-card/components/vehicle-rental-price-tab/interfaces/vehicle-rental-price-intefaces";
import { GenericTotalModel } from "./total/genericTotal.model";

export class BookingModel extends GenericModel {
    public code: string;
    public xId: string;
    public xStatus: string;
    public xTarget: string;
    public xType: string;
    public host: HostModel;
    public agency: AgencyModel;
    public customer: CustomerModel;
    public owner: OwnerModel;
    public priceArray: PriceModel[];
    public total: TotalModel;
    public syscode: SyscodeModel;
    public voucherArray: VoucherModel[];
    public vehicleArray: VehicleModel[];
    public typeArray: string[];
    public serviceArray: ServiceModel[];
    public vehicleRentalArray: VehicleRentalModel[];
    public productArray: ProductModel[];
    public travellerArray: TravellerModel[];

    // TODO paymentArray: PaymentModel[];

    public sumBaseByxSellLocation(xSellLocation: ('Merchant' | 'Local'), title: string): IVehicleRentalPriceRow {
        const totalPriceVehicleObject: PriceModel = this.priceArray?.find((price: PriceModel): boolean => price?.cost?.xRole === 'Vehicle');
        const totalBaseObject: GenericTotalModel = totalPriceVehicleObject?.cost?.total?.baseArray?.find((total: GenericTotalModel): boolean => total?.xSellLocation === xSellLocation);
        return {
            title,
            type: EVehicleRowType.base,
            total: {
                amount: +totalBaseObject?.currencyArray[0]?.amount,
                currency: totalBaseObject?.currencyArray[0]?.currencyCode
            },
            collapseGroup: xSellLocation
        };
    }

    public sumFeeByxSellLocation(xSellLocation: ('Merchant' | 'Local'), title: string): IVehicleRentalPriceRow {
        const totalPricevehicleObject = this.priceArray?.find((price: PriceModel) => price?.cost?.xRole === 'Vehicle');
        const totalFeeObject: GenericTotalModel = totalPricevehicleObject?.cost?.total?.feeArray?.find((total: GenericTotalModel) => total?.xSellLocation === xSellLocation);
        return {
            title,
            type: EVehicleRowType.fee,
            total: {
                amount: +totalFeeObject?.currencyArray[0]?.amount,
                currency: totalFeeObject?.currencyArray[0]?.currencyCode
            },
            collapseGroup: xSellLocation
        };
        return null;
    }

    public merchantOrLocalRowDefinition(totalService: IVehicleRentalPriceRow,
                                        totalBase: IVehicleRentalPriceRow,
                                        totalFee: IVehicleRentalPriceRow,
                                        xSellLocation: ('Merchant' | 'Local'),
                                        title: string,
                                        ): IVehicleRentalPriceRow {
        const hasPrices: boolean = Boolean(totalBase?.total?.amount) || Boolean(totalFee?.total?.amount) || Boolean(totalService?.total?.amount);
        if (!hasPrices) {
            return null;
        }

        return {
            title,
            type: EVehicleRowType.total,
            total: {
                amount: totalBase.total.amount + totalFee.total.amount + totalService.total.amount,
                currency: totalBase.total.currency
            },
            collapser: xSellLocation
        };
    }

    public get vehicleRental(): VehicleRentalModel {
        return this.vehicleRentalArray[0];
    }

    public getVehicleByXRef(xRef: string): VehicleModel {
        return this.vehicleArray.find((vehicle: VehicleModel): boolean => vehicle.xId === xRef) ?? null;
    }

    public getServicesName(): string[] {
        return this.serviceArray.map((s: ServiceModel) => s.name);
    }

    protected fromJson(json?: any): boolean {
        this.code = json.code ?? null;
        this.xId = json.xId ?? null;
        this.xStatus = json.xStatus ?? null;
        this.xTarget = json.xTarget ?? null;
        this.xType = json.xType ?? null;
        this.host = makeModel(json.host, HostModel);
        this.agency = makeModel(json.agency, AgencyModel);
        this.customer = makeModel(json.customer, CustomerModel);
        this.owner = makeModel(json.owner, OwnerModel);
        this.priceArray = makeModel(json.priceArray, PriceModel);
        this.total = makeModel(json.total?.cost, TotalModel);
        this.syscode = makeModel(json.syscode, SyscodeModel);
        this.voucherArray = makeModel(json.voucherArray, VoucherModel);
        this.vehicleArray = makeModel(json.vehicleArray, VehicleModel);
        this.typeArray = json.typeArray ?? null;
        this.serviceArray = makeModel(json.serviceArray, ServiceModel);
        this.vehicleRentalArray = makeModel(json.vehicleRentalArray, VehicleRentalModel);
        this.productArray = makeModel(json.productArray, ProductModel);
        this.travellerArray = makeModel(json.travellerArray, TravellerModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.code !== null && this.host !== null && this.vehicleRentalArray !== null && this.vehicleRentalArray.length > 0 && this.vehicleArray !== null;
    }


    public getVehicleFeatures(): string[] {
        const features: string[] = [];
        this.vehicleArray.map((feature: VehicleModel) => {
            if (feature.xSize.toLowerCase() !== 'unknown') {
                features.push(feature.xSize);
            }
            if (feature.occupancy !== 0) {
                features.push(feature.occupancy + " passengers");
            }
            if (feature.luggageCapacity) {
                features.push(feature.luggageCapacity + " luggages");
            }
            if (feature.doorsQuantity !== 0) {
                features.push(feature.doorsQuantity + " doors");
            }
            if (feature.xFuel.toLowerCase() !== 'unknown') {
                features.push("Fuel :" + feature.xFuel);
            }
            if (feature.xAirConditioning.toLowerCase() === 'airconditioned') {
                features.push("Air Conditioning");
            }
            if (feature.xTransmission.toLowerCase() !== 'unknown') {
                features.push(feature.xTransmission);
            }
        });
        return features;
    }
}
